<template>
    <div class="modal-content deletAccount-modal">
        <div class="deletAccount-content">
            <div class="deletAccount-title">{{ $t('are-you-sure', 'Are You Sure') }}?</div>
            <div class="deletAccount-text">
                <span>{{ $t('do-you-really-want-to-delete-this-account', 'Do You Really Want To Delete This Account') }} ?</span>
            </div>
            <div class="deletAccount-button-wrap">
                <button @click="$emit('close')" id="closeBtn" data-bs-dismiss="modal" class="deletAccount-no">{{ $t('no', 'No') }}</button>
                <button @click="deleteServiceCall()" class="deletAccount-yes">{{ $t('yes', 'Yes') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { removeAccount } from '../services/walletWithdraw'

export default {
    name: "DeleteAccountModal",
    methods:{
        async deleteServiceCall() {
            let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
        }
    },
    props:['item'],
    emits: ['close', 'success-modal', 'error-modal', 'yes-click'],
};
</script>